export enum UserRoleEnum {
    None = 0,
    Administrator = 1,
    Supervisor = 12024,
    TaskManager = 12025,
    ReportAdmin = 12029,
    Subcontractor = 12030,
    ProcessAdmin = 12023,
    User = 12028
}
